import React from "react";

const Free = React.forwardRef(
  (
    {
      width = "16",
      height = "16",
      viewBox = "0 0 16 16",
      fill = "none",
      fillColor = "#11C182",

      className,

      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Free" clipPath="url(#clip0_1116_10213)">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.94754 0.91059L9.90023 1.62371C10.1608 1.81875 10.435 1.91856 10.76 1.93665L11.9482 2.00275C12.6596 2.04231 13.2375 2.52715 13.4 3.22096L13.6714 4.37962C13.7456 4.6965 13.8916 4.94925 14.1289 5.17197L14.9966 5.98637C15.5162 6.474 15.6471 7.21684 15.3257 7.85278L14.7889 8.91481C14.642 9.20528 14.5914 9.49268 14.63 9.81584L14.7712 10.9975C14.8558 11.705 14.4786 12.3582 13.8236 12.6387L12.7297 13.1072C12.4305 13.2354 12.207 13.423 12.0288 13.6953L11.3775 14.6913C10.9875 15.2876 10.2787 15.5456 9.59661 15.3395L8.45748 14.9952C8.14595 14.9011 7.85411 14.9011 7.54254 14.9952L6.40342 15.3395C5.72136 15.5456 5.01254 15.2876 4.62254 14.6913L3.9712 13.6953C3.79304 13.423 3.56948 13.2354 3.27032 13.1072L2.17632 12.6387C1.52132 12.3582 1.14417 11.7049 1.22873 10.9974L1.36998 9.81578C1.40861 9.49262 1.35792 9.20521 1.21111 8.91475L0.674262 7.85272C0.352824 7.21681 0.483793 6.47396 1.00336 5.98631L1.87107 5.1719C2.10839 4.94918 2.25429 4.69643 2.32851 4.37956L2.59995 3.2209C2.76245 2.52712 3.34029 2.04228 4.05176 2.00268L5.23992 1.93659C5.56489 1.91853 5.83914 1.81868 6.0997 1.62365L7.05239 0.910527C7.62279 0.48359 8.37711 0.48359 8.94754 0.91059ZM7.39223 8.40806L6.35836 7.37418C6.09039 7.10622 5.65573 7.10622 5.38779 7.37418C5.11982 7.64215 5.11982 8.07678 5.38779 8.34475L6.90845 9.86537C7.17642 10.1333 7.61107 10.1333 7.87901 9.86537C8.79557 8.94878 9.70176 8.0219 10.6141 7.10112C10.8801 6.83262 10.8793 6.39937 10.6111 6.13271C10.3429 5.866 9.90845 5.86675 9.64214 6.13572L7.39223 8.40806ZM7.99995 2.88912C6.58867 2.88912 5.31095 3.46118 4.38607 4.38606C3.4612 5.31096 2.88914 6.58865 2.88914 7.99993C2.88914 9.41121 3.4612 10.6889 4.38607 11.6138C5.31095 12.5387 6.58867 13.1107 7.99995 13.1107C9.41123 13.1107 10.6889 12.5387 11.6138 11.6138C12.5387 10.6889 13.1108 9.41121 13.1108 7.99993C13.1108 6.58865 12.5387 5.31093 11.6138 4.38606C10.6889 3.46118 9.41123 2.88912 7.99995 2.88912ZM11.2603 4.73959C10.4259 3.90522 9.2732 3.38912 7.99995 3.38912C6.7267 3.38912 5.57398 3.90522 4.73961 4.73959C3.90523 5.57397 3.38914 6.72668 3.38914 7.99993C3.38914 9.27318 3.90523 10.4259 4.73961 11.2603C5.57398 12.0947 6.7267 12.6107 7.99995 12.6107C9.2732 12.6107 10.4259 12.0947 11.2603 11.2603C12.0947 10.4259 12.6107 9.27322 12.6107 7.99997C12.6108 6.72668 12.0947 5.57397 11.2603 4.73959Z"
            fill={fillColor}
          />
        </g>
        <defs>
          <clipPath id="clip0_1116_10213">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
export default Free;
